const countries = [
   {"title": 'Afghanistan', "const": 'AF'},
   {"title": 'Åland Islands', "const": 'AX'},
   {"title": 'Albania', "const": 'AL'},
   {"title": 'Algeria', "const": 'DZ'},
   {"title": 'American Samoa', "const": 'AS'},
   {"title": 'AndorrA', "const": 'AD'},
   {"title": 'Angola', "const": 'AO'},
   {"title": 'Anguilla', "const": 'AI'},
   {"title": 'Antarctica', "const": 'AQ'},
   {"title": 'Antigua and Barbuda', "const": 'AG'},
   {"title": 'Argentina', "const": 'AR'},
   {"title": 'Armenia', "const": 'AM'},
   {"title": 'Aruba', "const": 'AW'},
   {"title": 'Australia', "const": 'AU'},
   {"title": 'Austria', "const": 'AT'},
   {"title": 'Azerbaijan', "const": 'AZ'},
   {"title": 'Bahamas', "const": 'BS'},
   {"title": 'Bahrain', "const": 'BH'},
   {"title": 'Bangladesh', "const": 'BD'},
   {"title": 'Barbados', "const": 'BB'},
   {"title": 'Belarus', "const": 'BY'},
   {"title": 'Belgium', "const": 'BE'},
   {"title": 'Belize', "const": 'BZ'},
   {"title": 'Benin', "const": 'BJ'},
   {"title": 'Bermuda', "const": 'BM'},
   {"title": 'Bhutan', "const": 'BT'},
   {"title": 'Bolivia', "const": 'BO'},
   {"title": 'Bosnia and Herzegovina', "const": 'BA'},
   {"title": 'Botswana', "const": 'BW'},
   {"title": 'Bouvet Island', "const": 'BV'},
   {"title": 'Brazil', "const": 'BR'},
   {"title": 'British Indian Ocean Territory', "const": 'IO'},
   {"title": 'Brunei Darussalam', "const": 'BN'},
   {"title": 'Bulgaria', "const": 'BG'},
   {"title": 'Burkina Faso', "const": 'BF'},
   {"title": 'Burundi', "const": 'BI'},
   {"title": 'Cambodia', "const": 'KH'},
   {"title": 'Cameroon', "const": 'CM'},
   {"title": 'Canada', "const": 'CA'},
   {"title": 'Cape Verde', "const": 'CV'},
   {"title": 'Cayman Islands', "const": 'KY'},
   {"title": 'Central African Republic', "const": 'CF'},
   {"title": 'Chad', "const": 'TD'},
   {"title": 'Chile', "const": 'CL'},
   {"title": 'China', "const": 'CN'},
   {"title": 'Christmas Island', "const": 'CX'},
   {"title": 'Cocos (Keeling) Islands', "const": 'CC'},
   {"title": 'Colombia', "const": 'CO'},
   {"title": 'Comoros', "const": 'KM'},
   {"title": 'Congo', "const": 'CG'},
   {"title": 'Congo, The Democratic Republic of the', "const": 'CD'},
   {"title": 'Cook Islands', "const": 'CK'},
   {"title": 'Costa Rica', "const": 'CR'},
   {"title": 'Cote D\'Ivoire', "const": 'CI'},
   {"title": 'Croatia', "const": 'HR'},
   {"title": 'Cuba', "const": 'CU'},
   {"title": 'Cyprus', "const": 'CY'},
   {"title": 'Czech Republic', "const": 'CZ'},
   {"title": 'Denmark', "const": 'DK'},
   {"title": 'Djibouti', "const": 'DJ'},
   {"title": 'Dominica', "const": 'DM'},
   {"title": 'Dominican Republic', "const": 'DO'},
   {"title": 'Ecuador', "const": 'EC'},
   {"title": 'Egypt', "const": 'EG'},
   {"title": 'El Salvador', "const": 'SV'},
   {"title": 'Equatorial Guinea', "const": 'GQ'},
   {"title": 'Eritrea', "const": 'ER'},
   {"title": 'Estonia', "const": 'EE'},
   {"title": 'Ethiopia', "const": 'ET'},
   {"title": 'Falkland Islands (Malvinas)', "const": 'FK'},
   {"title": 'Faroe Islands', "const": 'FO'},
   {"title": 'Fiji', "const": 'FJ'},
   {"title": 'Finland', "const": 'FI'},
   {"title": 'France', "const": 'FR'},
   {"title": 'French Guiana', "const": 'GF'},
   {"title": 'French Polynesia', "const": 'PF'},
   {"title": 'French Southern Territories', "const": 'TF'},
   {"title": 'Gabon', "const": 'GA'},
   {"title": 'Gambia', "const": 'GM'},
   {"title": 'Georgia', "const": 'GE'},
   {"title": 'Germany', "const": 'DE'},
   {"title": 'Ghana', "const": 'GH'},
   {"title": 'Gibraltar', "const": 'GI'},
   {"title": 'Greece', "const": 'GR'},
   {"title": 'Greenland', "const": 'GL'},
   {"title": 'Grenada', "const": 'GD'},
   {"title": 'Guadeloupe', "const": 'GP'},
   {"title": 'Guam', "const": 'GU'},
   {"title": 'Guatemala', "const": 'GT'},
   {"title": 'Guernsey', "const": 'GG'},
   {"title": 'Guinea', "const": 'GN'},
   {"title": 'Guinea-Bissau', "const": 'GW'},
   {"title": 'Guyana', "const": 'GY'},
   {"title": 'Haiti', "const": 'HT'},
   {"title": 'Heard Island and Mcdonald Islands', "const": 'HM'},
   {"title": 'Holy See (Vatican City State)', "const": 'VA'},
   {"title": 'Honduras', "const": 'HN'},
   {"title": 'Hong Kong', "const": 'HK'},
   {"title": 'Hungary', "const": 'HU'},
   {"title": 'Iceland', "const": 'IS'},
   {"title": 'India', "const": 'IN'},
   {"title": 'Indonesia', "const": 'ID'},
   {"title": 'Iran, Islamic Republic Of', "const": 'IR'},
   {"title": 'Iraq', "const": 'IQ'},
   {"title": 'Ireland', "const": 'IE'},
   {"title": 'Isle of Man', "const": 'IM'},
   {"title": 'Israel', "const": 'IL'},
   {"title": 'Italy', "const": 'IT'},
   {"title": 'Jamaica', "const": 'JM'},
   {"title": 'Japan', "const": 'JP'},
   {"title": 'Jersey', "const": 'JE'},
   {"title": 'Jordan', "const": 'JO'},
   {"title": 'Kazakhstan', "const": 'KZ'},
   {"title": 'Kenya', "const": 'KE'},
   {"title": 'Kiribati', "const": 'KI'},
   {"title": 'Korea, Democratic People\'S Republic of', "const": 'KP'},
   {"title": 'Korea, Republic of', "const": 'KR'},
   {"title": 'Kuwait', "const": 'KW'},
   {"title": 'Kyrgyzstan', "const": 'KG'},
   {"title": 'Lao People\'S Democratic Republic', "const": 'LA'},
   {"title": 'Latvia', "const": 'LV'},
   {"title": 'Lebanon', "const": 'LB'},
   {"title": 'Lesotho', "const": 'LS'},
   {"title": 'Liberia', "const": 'LR'},
   {"title": 'Libyan Arab Jamahiriya', "const": 'LY'},
   {"title": 'Liechtenstein', "const": 'LI'},
   {"title": 'Lithuania', "const": 'LT'},
   {"title": 'Luxembourg', "const": 'LU'},
   {"title": 'Macao', "const": 'MO'},
   {"title": 'Macedonia, The Former Yugoslav Republic of', "const": 'MK'},
   {"title": 'Madagascar', "const": 'MG'},
   {"title": 'Malawi', "const": 'MW'},
   {"title": 'Malaysia', "const": 'MY'},
   {"title": 'Maldives', "const": 'MV'},
   {"title": 'Mali', "const": 'ML'},
   {"title": 'Malta', "const": 'MT'},
   {"title": 'Marshall Islands', "const": 'MH'},
   {"title": 'Martinique', "const": 'MQ'},
   {"title": 'Mauritania', "const": 'MR'},
   {"title": 'Mauritius', "const": 'MU'},
   {"title": 'Mayotte', "const": 'YT'},
   {"title": 'Mexico', "const": 'MX'},
   {"title": 'Micronesia, Federated States of', "const": 'FM'},
   {"title": 'Moldova, Republic of', "const": 'MD'},
   {"title": 'Monaco', "const": 'MC'},
   {"title": 'Mongolia', "const": 'MN'},
   {"title": 'Montserrat', "const": 'MS'},
   {"title": 'Morocco', "const": 'MA'},
   {"title": 'Mozambique', "const": 'MZ'},
   {"title": 'Myanmar', "const": 'MM'},
   {"title": 'Namibia', "const": 'NA'},
   {"title": 'Nauru', "const": 'NR'},
   {"title": 'Nepal', "const": 'NP'},
   {"title": 'Netherlands', "const": 'NL'},
   {"title": 'Netherlands Antilles', "const": 'AN'},
   {"title": 'New Caledonia', "const": 'NC'},
   {"title": 'New Zealand', "const": 'NZ'},
   {"title": 'Nicaragua', "const": 'NI'},
   {"title": 'Niger', "const": 'NE'},
   {"title": 'Nigeria', "const": 'NG'},
   {"title": 'Niue', "const": 'NU'},
   {"title": 'Norfolk Island', "const": 'NF'},
   {"title": 'Northern Mariana Islands', "const": 'MP'},
   {"title": 'Norway', "const": 'NO'},
   {"title": 'Oman', "const": 'OM'},
   {"title": 'Pakistan', "const": 'PK'},
   {"title": 'Palau', "const": 'PW'},
   {"title": 'Palestinian Territory, Occupied', "const": 'PS'},
   {"title": 'Panama', "const": 'PA'},
   {"title": 'Papua New Guinea', "const": 'PG'},
   {"title": 'Paraguay', "const": 'PY'},
   {"title": 'Peru', "const": 'PE'},
   {"title": 'Philippines', "const": 'PH'},
   {"title": 'Pitcairn', "const": 'PN'},
   {"title": 'Poland', "const": 'PL'},
   {"title": 'Portugal', "const": 'PT'},
   {"title": 'Puerto Rico', "const": 'PR'},
   {"title": 'Qatar', "const": 'QA'},
   {"title": 'Reunion', "const": 'RE'},
   {"title": 'Romania', "const": 'RO'},
   {"title": 'Russian Federation', "const": 'RU'},
   {"title": 'RWANDA', "const": 'RW'},
   {"title": 'Saint Helena', "const": 'SH'},
   {"title": 'Saint Kitts and Nevis', "const": 'KN'},
   {"title": 'Saint Lucia', "const": 'LC'},
   {"title": 'Saint Pierre and Miquelon', "const": 'PM'},
   {"title": 'Saint Vincent and the Grenadines', "const": 'VC'},
   {"title": 'Samoa', "const": 'WS'},
   {"title": 'San Marino', "const": 'SM'},
   {"title": 'Sao Tome and Principe', "const": 'ST'},
   {"title": 'Saudi Arabia', "const": 'SA'},
   {"title": 'Senegal', "const": 'SN'},
   {"title": 'Serbia and Montenegro', "const": 'CS'},
   {"title": 'Seychelles', "const": 'SC'},
   {"title": 'Sierra Leone', "const": 'SL'},
   {"title": 'Singapore', "const": 'SG'},
   {"title": 'Slovakia', "const": 'SK'},
   {"title": 'Slovenia', "const": 'SI'},
   {"title": 'Solomon Islands', "const": 'SB'},
   {"title": 'Somalia', "const": 'SO'},
   {"title": 'South Africa', "const": 'ZA'},
   {"title": 'South Georgia and the South Sandwich Islands', "const": 'GS'},
   {"title": 'Spain', "const": 'ES'},
   {"title": 'Sri Lanka', "const": 'LK'},
   {"title": 'Sudan', "const": 'SD'},
   {"title": 'Suri"title"', "const": 'SR'},
   {"title": 'Svalbard and Jan Mayen', "const": 'SJ'},
   {"title": 'Swaziland', "const": 'SZ'},
   {"title": 'Sweden', "const": 'SE'},
   {"title": 'Switzerland', "const": 'CH'},
   {"title": 'Syrian Arab Republic', "const": 'SY'},
   {"title": 'Taiwan, Province of China', "const": 'TW'},
   {"title": 'Tajikistan', "const": 'TJ'},
   {"title": 'Tanzania, United Republic of', "const": 'TZ'},
   {"title": 'Thailand', "const": 'TH'},
   {"title": 'Timor-Leste', "const": 'TL'},
   {"title": 'Togo', "const": 'TG'},
   {"title": 'Tokelau', "const": 'TK'},
   {"title": 'Tonga', "const": 'TO'},
   {"title": 'Trinidad and Tobago', "const": 'TT'},
   {"title": 'Tunisia', "const": 'TN'},
   {"title": 'Turkey', "const": 'TR'},
   {"title": 'Turkmenistan', "const": 'TM'},
   {"title": 'Turks and Caicos Islands', "const": 'TC'},
   {"title": 'Tuvalu', "const": 'TV'},
   {"title": 'Uganda', "const": 'UG'},
   {"title": 'Ukraine', "const": 'UA'},
   {"title": 'United Arab Emirates', "const": 'AE'},
   {"title": 'United Kingdom', "const": 'GB'},
   {"title": 'United States', "const": 'US'},
   {"title": 'United States Minor Outlying Islands', "const": 'UM'},
   {"title": 'Uruguay', "const": 'UY'},
   {"title": 'Uzbekistan', "const": 'UZ'},
   {"title": 'Vanuatu', "const": 'VU'},
   {"title": 'Venezuela', "const": 'VE'},
   {"title": 'Viet Nam', "const": 'VN'},
   {"title": 'Virgin Islands, British', "const": 'VG'},
   {"title": 'Virgin Islands, U.S.', "const": 'VI'},
   {"title": 'Wallis and Futuna', "const": 'WF'},
   {"title": 'Western Sahara', "const": 'EH'},
   {"title": 'Yemen', "const": 'YE'},
   {"title": 'Zambia', "const": 'ZM'},
   {"title": 'Zimbabwe', "const": 'ZW'}
]

export default countries
